import { LookupResponse } from '@core/models/common.model';

// Reading the reference lists a form is given (by the lookup store, keyed by list). Pure, so any component can share them.

export type Lookups = Record<string, LookupResponse[]>;

// The items of one list ([] while it has not arrived).
export function lookupItems(lookups: Lookups, key: string): LookupResponse[] {
  return lookups[key] ?? [];
}

// The name of one item of a list, for labels built from a row's id.
export function lookupName(lookups: Lookups, key: string, id: unknown): string {
  const item = lookupItems(lookups, key).find((entry) => entry.id === id);
  return item?.name ?? item?.code ?? '';
}

// The description of one item of a list (for example a life stage's age range).
export function lookupDescription(lookups: Lookups, key: string, id: unknown): string {
  return lookupItems(lookups, key).find((entry) => entry.id === id)?.description ?? '';
}

// The item chosen in a list is "Other" (by its code or name), which asks for a text.
export function isOtherLookupSelection(lookups: Lookups, lookupKey: string, selectedId: string | null | undefined): boolean {
  if (!selectedId) {
    return false;
  }

  const selected = lookupItems(lookups, lookupKey).find((item) => item.id === selectedId);
  const normalizedValues = [selected?.code, selected?.name]
    .filter((value): value is string => Boolean(value))
    .map((value) => value.toLowerCase().replace(/[^a-z]/g, ''));

  return normalizedValues.some((value) => value === 'other' || value === 'oth');
}
